

document.addEventListener("click", function (e) {
    const tab = e.target.closest(".funding-widget__tab");
    if (!tab) return;

    const widget = tab.closest(".funding-widget");
    const selectedTab = tab.getAttribute("data-tab");

    activateFundingTab(widget, selectedTab);
});

document.addEventListener("change", function (e) {
    const select = e.target.closest(".funding-widget__select");
    if (!select) return;

    const widget = select.closest(".funding-widget");
    activateFundingTab(widget, select.value);
});

function activateFundingTab(widget, selectedTab) {
    widget.querySelectorAll(".funding-widget__tab")
        .forEach(t => t.classList.remove("active"));

    widget.querySelectorAll(".funding-widget__content")
        .forEach(c => c.classList.remove("active"));

    const activeTab = widget.querySelector(
        `.funding-widget__tab[data-tab="${selectedTab}"]`
    );

    const activeContent = widget.querySelector(
        `.funding-widget__content[data-content="${selectedTab}"]`
    );

    const mobileSelect = widget.querySelector(".funding-widget__select");

    if (activeTab) activeTab.classList.add("active");
    if (activeContent) activeContent.classList.add("active");
    if (mobileSelect) mobileSelect.value = selectedTab;

    //SET USER CHOICE VALUE
    const userChoiceInput = widget.querySelector('input[name*="UserChoice"]');

    if (userChoiceInput) {
        if (activeTab) {
            userChoiceInput.value = activeTab.textContent.trim();
        } else if (mobileSelect) {
            userChoiceInput.value = mobileSelect.options[mobileSelect.selectedIndex].text.trim();
        }
    }
}

function getFundingTableCellHtml(cell) {
    if (!cell) return "";

    const clone = cell.cloneNode(true);

    while (clone.lastChild && clone.lastChild.nodeName.toLowerCase() === "br") {
        clone.removeChild(clone.lastChild);
    }

    return clone.innerHTML
        .replace(/&nbsp;/gi, " ")
        .trim();
}

function hasFundingTableCellContent(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    return temp.textContent.replace(/\u00a0/g, " ").trim().length > 0;
}

function enhanceFundingWidgetContentTables(widget) {
    widget.querySelectorAll(".funding-widget__text table").forEach(function (table) {
        const rows = Array.from(table.querySelectorAll("tr"))
            .map(function (row) {
                return Array.from(row.children).filter(function (cell) {
                    return cell.tagName.toLowerCase() === "td" || cell.tagName.toLowerCase() === "th";
                });
            });

        if (!rows.length || rows[0].length < 2) return;

        const headings = [
            getFundingTableCellHtml(rows[0][0]),
            getFundingTableCellHtml(rows[0][1])
        ];

        const items = [[], []];

        rows.slice(1).forEach(function (row) {
            [0, 1].forEach(function (index) {
                const html = getFundingTableCellHtml(row[index]);

                if (hasFundingTableCellContent(html)) {
                    items[index].push(html);
                }
            });
        });

        if (!items[0].length && !items[1].length) return;

        const split = document.createElement("div");
        split.className = "funding-widget__split-table";

        [0, 1].forEach(function (index) {
            const column = document.createElement("div");
            column.className = "funding-widget__split-table-column";

            if (hasFundingTableCellContent(headings[index])) {
                const heading = document.createElement("div");
                heading.className = "funding-widget__split-table-heading";
                heading.innerHTML = headings[index];
                column.appendChild(heading);
            }

            const list = document.createElement("ul");
            items[index].forEach(function (html) {
                const item = document.createElement("li");
                item.innerHTML = html;
                list.appendChild(item);
            });
            column.appendChild(list);
            split.appendChild(column);
        });

        table.parentNode.replaceChild(split, table);
    });
}

function syncFundingWidgetTabIcon(iconContainer) {
    const fallbackIcon = iconContainer.querySelector(".funding-widget__tab-svg--default");
    const openDialog = iconContainer.querySelector(".openDialog");

    if (!fallbackIcon || !openDialog) return;

    fallbackIcon.classList.toggle(
        "funding-widget__tab-svg--hidden",
        openDialog.querySelector("svg") !== null
    );
}

function renderFundingWidgetSelectedTabIcon(editor, iconName) {
    if (!iconName) return;

    const openDialog = editor.querySelector(".openDialog");
    const spriteUrl = editor.getAttribute("data-sprite-url");

    if (!openDialog || !spriteUrl) return;

    openDialog.innerHTML = '<svg class="funding-widget__tab-svg icon product"><use xlink:href="' + spriteUrl + '#' + iconName + '"></use></svg>';
}

function initialiseFundingWidgetIconPickers(widget) {
    widget.querySelectorAll(".funding-widget__icon").forEach(function (iconContainer) {
        const editor = iconContainer.querySelector("[data-sprite-url]");
        const openDialog = iconContainer.querySelector(".openDialog");

        syncFundingWidgetTabIcon(iconContainer);

        if (editor) {
            editor.addEventListener("updateProperty", function (event) {
                renderFundingWidgetSelectedTabIcon(editor, event.detail.value);
                syncFundingWidgetTabIcon(iconContainer);
            });
        }

        if (openDialog && window.MutationObserver) {
            new MutationObserver(function () {
                syncFundingWidgetTabIcon(iconContainer);
            }).observe(openDialog, {
                childList: true,
                subtree: true
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".funding-widget").forEach(function (widget) {
        enhanceFundingWidgetContentTables(widget);
        initialiseFundingWidgetIconPickers(widget);

        const activeTab = widget.querySelector(".funding-widget__tab.active");

        const select = widget.querySelector(".funding-widget__select");

        const selectedTab = activeTab
            ? activeTab.getAttribute("data-tab")
            : (select ? select.value : null);

        //const selectedTab = activeTab
        //    ? activeTab.getAttribute("data-tab")
        //    : widget.querySelector(".funding-widget__select")?.value;

        if (selectedTab) {
            activateFundingTab(widget, selectedTab);
        }
    });
});
